import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";

const MakeTemplateToDeviceModal = props => {
  const deviceNameMenuItems = props.devices.map(d => (
    <MenuItem value={d.identifier} key={d.identifier}>
      {props.modalData.submission_device === d.owner ? (
        <b>{d.owner} (Issuing Device)</b>
      ) : (
        d.owner
      )}
    </MenuItem>
  ));

  // If this is an update, show the diff between the old row and new row.
  // otherwise its an insert, just show new data.
  return (
    <Dialog
      open={props.makeTemplateToDeviceModalOpen}
      fullWidth
      max-width="400"
      onClose={props.onMakeTemplateCloseClick}
      scroll="body"
    >
      <DialogTitle>Send as Template to Device</DialogTitle>
      <DialogContent>
        {props.isFetchingDevices ? (
          <div>
            <Typography>Loading Devices..</Typography>
            <LinearProgress />
          </div>
        ) : (
          <DialogContentText>
            <b>Form name:</b>
            <br /> {props.modalData.form_name}
            <FormControl fullWidth style={{ marginTop: "20px" }}>
              <InputLabel>Device</InputLabel>
              <Select
                value={props.deviceSelected.device}
                onChange={e => props.onMakeTemplateDeviceChange(e.target.value)}
              >
                {deviceNameMenuItems}
              </Select>
            </FormControl>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          disabled={props.isFetchingDevices}
          onClick={props.onMakeTemplateSaveClick}
        >
          Send
        </Button>

        <Button color="primary" onClick={props.onMakeTemplateCloseClick}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MakeTemplateToDeviceModal.defaultProps = {
  makeTemplateToDeviceModalOpen: false
};

MakeTemplateToDeviceModal.propTypes = {
  modalData: PropTypes.shape({
    submission_device: PropTypes.string,
    form_name: PropTypes.string
  }).isRequired,
  onMakeTemplateSaveClick: PropTypes.func.isRequired,
  onMakeTemplateDeviceChange: PropTypes.func.isRequired,
  onMakeTemplateCloseClick: PropTypes.func.isRequired,
  deviceSelected: PropTypes.shape({
    device: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  isFetchingDevices: PropTypes.bool.isRequired,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      identifier: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  makeTemplateToDeviceModalOpen: PropTypes.bool
};

export default MakeTemplateToDeviceModal;
